// Kroatische Oberflaechen-Texte Teil 2, erstellt 15.09.2026, gegenzulesen. Schluessel = deutscher Text.

export const UI_HR_TEIL2 = {
  // Sichtpruefung (v71)
  'Sichtprüfungsprotokoll': 'Zapisnik vizualnog pregleda',
  'Nächste Sichtprüfung': 'Sljedeći vizualni pregled',
  'Sichtprüfung abschließen (Monteur)': 'Završi vizualni pregled (monter)',
  'Sichtprüfung durchgeführt von': 'Vizualni pregled proveo',
  // Pruefung 17.09.2026 (v70)
  'Zugang deaktiviert': 'Pristup deaktiviran',
  'Dein Zugang wurde vom Admin deaktiviert. Bitte im Büro melden.': 'Administrator je deaktivirao tvoj pristup. Molim javi se uredu.',
  'Kein Netz: Die Schienen werden aus dem Gerät angezeigt. Messwerte lassen sich eintragen, neue Schienen erst mit Netz anlegen.': 'Nema mreže: sabirnice se prikazuju s uređaja. Mjerne vrijednosti se mogu unijeti, nove sabirnice tek s mrežom.',
  'Die Schienen konnten nicht geladen werden (kein Netz?).': 'Sabirnice nije moguće učitati (nema mreže?).',
  // Vertraege / Absprachen (v69)
  'Notstromaggregat': 'agregat',
  'Mittelspannungsschaltanlage': 'srednjenaponsko rasklopno postrojenje',
  'Niederspannungshauptverteilung': 'glavni niskonaponski razvod',
  'Transformator': 'transformator',
  'Schalt- und Traforäume': 'rasklopne i trafo prostorije',
  'Erdungsanlage': 'uzemljenje',
  'Zubehör Transformatorstation': 'pribor trafostanice',
  'Überstromschutzrelais (Schutzprüfung)': 'nadstrujni zaštitni relej (ispitivanje zaštite)',
  'Blindleistungsregelanlage': 'postrojenje za kompenzaciju jalove snage',
  'Wartungsvertrag': 'Ugovor o održavanju',
  'Betriebsführungsvertrag': 'Ugovor o vođenju pogona',
  'Bereitschaft (Notdienst)': 'Dežurstvo (hitna služba)',
  'Schriftliche Freigabe des Kunden vor der Wartung nötig': 'Prije održavanja potrebno pisano odobrenje kupca',
  'Kunde informiert und beauftragt den Netzbetreiber': 'Kupac obavještava i angažira operatora mreže',
  'Kunde stellt Anlagenverantwortlichen und Schaltberechtigten': 'Kupac osigurava odgovornu osobu za postrojenje i osobu ovlaštenu za sklapanje',
  'Absprachen mit dem Kunden': 'Dogovori s kupcem',
  'Verträge:': 'Ugovori:',
  'Im Wartungsvertrag enthalten:': 'Uključeno u ugovor o održavanju:',
  'Abschaltung möglich:': 'Isključenje moguće:',
  'normale Arbeitszeit': 'redovno radno vrijeme',
  'abends': 'navečer',
  'nachts': 'noću',
  'Wochenende': 'vikend',
  'Feiertag': 'blagdan',
  'MS-Schaltanlage': 'SN rasklopno postrojenje',
  'Transformator(en)': 'transformator(i)',
  'Schalt- und Traforäume (Reinigung)': 'rasklopne i trafo prostorije (čišćenje)',
  'Erdungsanlage inkl. Messung': 'uzemljenje uklj. mjerenje',
  'Stationszubehör': 'pribor stanice',
  'Elektrothermografie': 'elektrotermografija',
  'Schutzprüfung UMZ': 'ispitivanje zaštite UMZ',
  'Notstromaggregat während der Wartung': 'agregat za vrijeme održavanja',
  'Ölprobe inklusive': 'uzorak ulja uključen',
  'Ölprobe nach Aufwand': 'uzorak ulja prema utrošku',
  'keine Ölprobe': 'bez uzorka ulja',
  'NSHV wird mitgewartet': 'glavni NN razvod se također održava',
  'NSHV wird bauseits gewartet': 'glavni NN razvod održava investitor',
  'Büro-Korrektur: Bewertung und Bemerkung lassen sich weiter ändern, die Unterschrift nicht. Ein bereits verschicktes PDF danach neu erstellen.': 'Ispravak ureda: ocjena i napomena se i dalje mogu mijenjati, potpis ne. Već poslani PDF zatim ponovno izraditi.',
  // Wandler im Protokoll (v67)
  'Zeile {nr} wurde von der Datenbank abgelehnt: {fehler}. Bitte im Büro Bescheid geben.': 'Bazu podataka je odbila redak {nr}: {fehler}. Molim javi uredu.',
  'Zeile konnte nicht angelegt werden: {fehler}': 'Redak nije moguće dodati: {fehler}',
  'Zeile konnte nicht entfernt werden: {fehler}': 'Redak nije moguće ukloniti: {fehler}',
  'Stromwandler {nr}': 'Strujni mjerni transformator {nr}',
  'Spannungswandler {nr}': 'Naponski mjerni transformator {nr}',
  'Wandler {nr} wirklich entfernen?': 'Zaista ukloniti mjerni transformator {nr}?',
  'Art': 'Vrsta',
  'Stromwandler': 'Strujni mjerni transformator',
  'Spannungswandler': 'Naponski mjerni transformator',
  'Bemessungsübersetzung': 'Nazivni prijenosni omjer',
  'z. B. 200/5 A': 'npr. 200/5 A',
  'Spannung e-n': 'Napon e-n',
  'z. B. 100/√3 V': 'npr. 100/√3 V',
  'Spannung U-X': 'Napon U-X',
  'Genauigkeitsklasse': 'Klasa točnosti',
  'z. B. 0,5s': 'npr. 0,5s',
  'Bemessungsbürde [VA]': 'Nazivno opterećenje [VA]',
  'Eichjahr': 'Godina ovjere',
  'Seriennummer L1': 'Serijski broj L1',
  'Seriennummer L2': 'Serijski broj L2',
  'Seriennummer L3': 'Serijski broj L3',
  'Wandler ({n})': 'Mjerni transformatori ({n})',
  'Kein Netz: Die Wandler sind auf dem Gerät gespeichert und werden automatisch gesendet.': 'Nema mreže: mjerni transformatori su spremljeni na uređaju i bit će automatski poslani.',
  'Noch keine Wandler erfasst. Unten hinzufügen.': 'Još nema unesenih mjernih transformatora. Dodaj dolje.',
  '+ Stromwandler': '+ Strujni mjerni transformator',
  '+ Spannungswandler': '+ Naponski mjerni transformator',
  // MS-Feldtypen und Bauformen (Migration 43)
  'R – Ringkabelfeld': 'R – polje prstenastog kabela',
  'T – Trafofeld (Trafoabgang)': 'T – transformatorsko polje',
  'L – Leistungsschalterfeld': 'L – polje s prekidačem snage',
  'M – Messfeld': 'M – mjerno polje',
  'Ü – Übergabefeld': 'Ü – predajno polje',
  'K – Kabelanschlussfeld (ohne Schalter)': 'K – polje kabelskog priključka (bez sklopke)',
  'S – Längstrennfeld (Lasttrennschalter)': 'S – polje uzdužnog odvajanja (rastavna sklopka)',
  'V – Kuppelfeld (Leistungsschalter)': 'V – spojno polje (prekidač snage)',
  'E – Sammelschienen-Erdungsfeld': 'E – polje uzemljenja sabirnica',
  'HF – Hochführungsfeld': 'HF – polje uzlaznog priključka',
  'G – Einspeisefeld Erzeugungsanlage (PV, BHKW, Speicher)': 'G – napojno polje proizvodnog postrojenja (FN, kogeneracija, spremnik)',
  'Sonstiges Feld': 'Ostalo polje',
  'Containerstation': 'Kontejnerska stanica',
  'Baustromstation': 'Gradilišna stanica',
  'Begehbare Station': 'Prohodna stanica',
  'Trafostation im Gebäude': 'Trafostanica u zgradi',
  'Sonstige': 'Ostalo',
  'Monteur fertig': 'Monter gotov',
  'Mängelliste (für Angebot)': 'Popis nedostataka (za ponudu)',
  'N-Leiter': 'N-vodič',
  'N-Leiter / PE+N-Leiter': 'N-vodič / PE+N-vodič',
  'NAYY-J/O': 'NAYY-J/O',
  'NICHT OK - Wanne zu klein': 'NIJE OK - kada je premala',
  'NS-Kabelverbindung Trafo zur NSHV': 'NN kabelska veza transformator – glavni NN razvod (NSHV)',
  'NSGAFÖU': 'NSGAFÖU',
  'NYCWY': 'NYCWY',
  'NYY': 'NYY',
  'NYY-J/O': 'NYY-J/O',
  'Name': 'Ime',
  'Name (gedruckt)': 'Ime (tiskanim slovima)',
  'Nein': 'Ne',
  'Netzsicherheit': 'Sigurnost mreže',
  'Netzsicherheit nicht gewährleistet': 'Sigurnost mreže nije zajamčena',
  'Neu laden hat nicht geklappt ({fehler}). Du kannst weiterarbeiten.': 'Ponovno učitavanje nije uspjelo ({fehler}). Možeš nastaviti raditi.',
  'Neue Schiene (z.B. Hauptpotentialausgleich)': 'Nova sabirnica (npr. glavno izjednačenje potencijala)',
  'Neues Passwort': 'Nova lozinka',
  'Neues Passwort setzen': 'Postavi novu lozinku',
  'Nicht angeschlossen': 'Nije priključeno',
  'Nicht benoetigt (Stand-alone)': 'Nije potrebno (samostalno)',
  'Nicht gespeichert: {fehler}': 'Nije spremljeno: {fehler}',
  'Nicht nötig, wenn alle Felder kapazitive Spannungsprüfsysteme haben – dann 05.24 prüfen.': 'Nije potrebno ako sva polja imaju kapacitivne sustave za ispitivanje napona – tada provjeri 05.24.',
  'Nicht vorhanden': 'Nije prisutno',
  'Noch kein Transformator. Auf "+ Transformator hinzufuegen" klicken.': 'Još nema transformatora. Klikni na "+ Dodaj transformator".',
  'Noch keine Anschlüsse — unten hinzufügen': 'Još nema priključaka — dodaj dolje',
  'Noch keine Bilder zu dieser Station. Du kannst hier direkt welche hinzufügen — oder die Monteure laden sie im Protokoll je Prüfpunkt hoch.': 'Još nema slika za ovu stanicu. Možeš ih dodati izravno ovdje — ili ih monteri učitaju u zapisniku po točki provjere.',
  'Noch keine Felder erfasst. Unten hinzufügen.': 'Još nema unesenih polja. Dodaj dolje.',
  'Noch keine Schiene angelegt. Unten neue Schiene hinzufügen.': 'Još nema sabirnice. Dodaj novu sabirnicu dolje.',
  'Nochmal versuchen': 'Pokušaj ponovno',
  'Normreihe, Sonderwerte frei eintippbar': 'Standardni niz, posebne vrijednosti možeš upisati',
  'Notiz zur Ölwanne (optional)': 'Bilješka o uljnoj kadi (neobavezno)',
  'Nur bei begehbarem MS-Raum mit Zwischenboden relevant.': 'Relevantno samo za prohodnu SN prostoriju s međupodom.',
  'Nur bei oel-gekuehlten Trafos': 'Samo kod transformatora hlađenih uljem',
  'Nur nötig, wenn die Felder kapazitive Prüfbuchsen haben (ältere Luftanlagen meist nicht).': 'Potrebno samo ako polja imaju kapacitivne ispitne utičnice (starija zračno izolirana postrojenja uglavnom nemaju).',
  'Nur nötig, wenn eine NS-Anlage vorhanden ist.': 'Potrebno samo ako postoji NN postrojenje.',
  'Nur relevant bei NS-Leistungsschalter am Trafo.': 'Relevantno samo kod NN prekidača snage na transformatoru.',
  'Nur sinnvoll, wenn das Büro den Grund behoben hat. Neuere Eingaben bleiben erhalten.': 'Ima smisla samo ako je ured otklonio uzrok. Noviji unosi ostaju sačuvani.',
  'Nächste Wartung': 'Sljedeće održavanje',
  'OK - Wanne faengt das gesamte Trafoeol auf': 'OK - kada prihvaća svo ulje transformatora',
  'OK Vom Büro freigegeben am {datum}': 'OK Ured odobrio dana {datum}',
  'OK gespeichert': 'OK spremljeno',
  'OL = über Messbereich (keine Verbindung)': 'OL = izvan mjernog opsega (nema spoja)',
  'OL = über Messbereich, keine Verbindung → Mangel': 'OL = izvan mjernog opsega, nema spoja → nedostatak',
  'OS gesteckt: geerdet wird über den Erdungsschalter im Trafofeld.': 'VN strana utaknuta: uzemljuje se preko zemljospojnika u transformatorskom polju.',
  'OS-Anschluss': 'VN priključak',
  'OS-Anzapfung automatisch berechnet:': 'VN odvojak automatski izračunat:',
  'OS-Anzapfungen [%]': 'VN odvojci [%]',
  'OS-Spannung [kV]': 'VN napon [kV]',
  'OS-Spannungen je Stufe [kV]': 'VN naponi po stupnju [kV]',
  'Ob alle Punkte beantwortet sind, ließ sich gerade nicht prüfen (kein Netz?).': 'Trenutno nije moguće provjeriti jesu li sve točke odgovorene (nema mreže?).',
  'Oel mit Ausdehner': 'Ulje s konzervatorom',
  'Oelgewicht [kg]': 'Masa ulja [kg]',
  'Offene Bauweise: Trenner werden mit der Schaltstange betätigt.': 'Otvorena izvedba: rastavljači se upravljaju sklopnom motkom.',
  'Offene OS-Anschlüsse: Der Trafo muss OS-seitig direkt geerdet werden können.': 'Otvoreni VN priključci: transformator se mora moći uzemljiti izravno na VN strani.',
  'Offene OS-Anschlüsse: Festpunkte zum Erden direkt am Trafo nötig.': 'Otvoreni VN priključci: potrebne su kuglaste točke za uzemljenje izravno na transformatoru.',
  'Offene US-Anschlüsse: Der Trafo muss auch US-seitig geerdet werden können.': 'Otvoreni NN priključci: transformator se mora moći uzemljiti i na NN strani.',
  'Offene US-Anschlüsse: Die US-Seite muss am Trafo geerdet werden können.': 'Otvoreni NN priključci: NN strana se mora moći uzemljiti na transformatoru.',
  'Offline': 'Izvan mreže',
  'Offline – Änderungen werden gespeichert und beim nächsten Empfang synchronisiert': 'Izvan mreže – promjene se spremaju i sinkroniziraju pri sljedećem signalu',
  'Ort': 'Mjesto',
  'PDF herunterladen': 'Preuzmi PDF',
  'PDF konnte nicht erstellt werden: {fehler}': 'PDF nije moguće izraditi: {fehler}',
  'PE + N-Leiter': 'PE + N-vodič',
  'PLZ': 'Poštanski broj',
  'PSA wird vor allem für Arbeiten an der NS-Verteilung gebraucht – Bedarf nach Gefährdungsbeurteilung.': 'OZO je potrebna prije svega za radove na NN razvodu – potreba prema procjeni rizika (GBU).',
  'Passwort bestätigen': 'Potvrdi lozinku',
  'Passwort erfolgreich geändert!': 'Lozinka uspješno promijenjena!',
  'Passwort muss mindestens 8 Zeichen lang sein.': 'Lozinka mora imati najmanje 8 znakova.',
  'Passwort speichern': 'Spremi lozinku',
  'Passwörter stimmen nicht überein.': 'Lozinke se ne podudaraju.',
  'Pause – später weiter': 'Pauza – nastavi kasnije',
  'Personensicherheit': 'Sigurnost osoba',
  'Personensicherheit nicht gewährleistet': 'Sigurnost osoba nije zajamčena',
  'Planung ändern': 'Promijeni plan',
  'Porzellan-Durchführungen (Kerzen)': 'Porculanski provodnici (izolatori)',
  'Pos. {pos} wurde NICHT gespeichert: {fehler}. Bitte im Büro Bescheid geben.': 'Poz. {pos} NIJE spremljena: {fehler}. Molim javi uredu.',
  'Position': 'Pozicija',
  'Protokoll vom Büro freigegeben.': 'Ured je odobrio zapisnik.',
  'Protokolle': 'Zapisnici',
  'Protokolle und PDF bleiben für das Büro und den Kunden auf Deutsch.': 'Zapisnici i PDF ostaju na njemačkom za ured i kupca.',
  'Prüfplakette angebracht': 'Ispitna naljepnica postavljena',
  'Querschnitt [mm²]': 'Presjek [mm²]',
  'R - Ringkabel': 'R - prstenasti kabel',
  'SF6': 'SF6',
  'SF6/Clean Air: Gasdruck- bzw. Bereitschaftsanzeige ablesen.': 'SF6/Clean Air: očitaj pokazivač tlaka plina odnosno spremnosti.',
  'SF6/Clean Air: Sicherungen sitzen in Kammern, die nur geerdet zugänglich sind – Wechsel ohne Zange.': 'SF6/Clean Air: osigurači su u komorama dostupnima samo kad su uzemljene – zamjena bez kliješta.',
  'SF6/Clean Air: kapazitive Prüfbuchsen – steckbares Anzeigegerät nötig (bei integrierter Anzeige wie CAPDIS/WEGA nicht). HR- und LRM-Geräte sind nicht tauschbar.': 'SF6/Clean Air: kapacitivne ispitne utičnice – potreban utični pokazivač (kod ugrađenog pokazivača kao CAPDIS/WEGA nije). HR i LRM uređaji nisu međusobno zamjenjivi.',
  'SF6/Clean-Air ohne Messfeld, Trafo gesteckt: Es gibt keine MS-Festpunkte zum Anlegen.': 'SF6/Clean-Air bez mjernog polja, transformator utaknut: nema SN kuglastih točaka za uzemljenje.',
  'Schaltgruppe': 'Grupa spoja',
  'Schaltstufen': 'Stupnjevi preklopke',
  'Schiene': 'Sabirnica',
  'Schiene "{name}" mit allen Anschlüssen wirklich löschen?': 'Stvarno obrisati sabirnicu "{name}" sa svim priključcima?',
  'Schiene löschen': 'Obriši sabirnicu',
  'Schienen und Anschlüsse werden in den Stammdaten der Station gespeichert. Der Ohm-Wert wird pro Wartung neu gemessen.': 'Sabirnice i priključci spremaju se u matične podatke stanice. Vrijednost u ohmima mjeri se ponovno pri svakom održavanju.',
  'Schließen': 'Zatvori',
  'Schutz am Trafo': 'Zaštita na transformatoru',
  'Schutz an MS-Anlage': 'Zaštita na SN postrojenju',
  'Schutzfunktionen': 'Zaštitne funkcije',
  'Schutzprüfung durchgeführt': 'Ispitivanje zaštite provedeno',
  'Selbst entscheiden': 'Odluči sam',
  'Senden fehlgeschlagen': 'Slanje nije uspjelo',
  'Seriennummer': 'Serijski broj',
  'Sicherheits-Bewertung': 'Sigurnosna ocjena',
  'Sie ist gespeichert und geht automatisch raus, sobald die Verbindung wieder steht.': 'Spremljeno je i automatski se šalje čim veza ponovno proradi.',
  'Sie sind auf dem Gerät aufbewahrt.': 'Spremljeni su na uređaju.',
  'Signatur löschen': 'Obriši potpis',
  'Sobald das Büro dir eine Wartung zuweist, steht sie hier. Du kannst auch selbst eine anlegen.': 'Čim ti ured dodijeli održavanje, pojavit će se ovdje. Možeš ga i sam kreirati.',
  'Sobald du eine Wartung planst, erscheint sie hier und beim zugewiesenen Monteur.': 'Čim isplaniraš održavanje, pojavit će se ovdje i kod dodijeljenog montera.',
  'Sonstiges': 'Ostalo',
  'Speichern': 'Spremi',
  'Speichert...': 'Sprema...',
  'Stammdaten': 'Matični podaci',
  'Stammdaten der Station werden geladen … (die Prüfpunkte unten lassen sich schon ausfüllen)': 'Učitavaju se matični podaci stanice … (točke provjere dolje već možeš ispunjavati)',
  'Starkstromkabel': 'Energetski kabel',
  'Station im Gebäude: Türfeststeller nur für Außentüren gefordert.': 'Stanica u zgradi: graničnik vrata potreban samo za vanjska vrata.',
  'Station im Gebäude: kein Regen an den Schlössern.': 'Stanica u zgradi: nema kiše na bravama.',
  'Station im Gebäude: kein eigenes Dach.': 'Stanica u zgradi: nema vlastiti krov.',
  'Station ohne Namen': 'Stanica bez naziva',
  'Stationen': 'Stanice',
  'Stations-Nr': 'Br. stanice',
  'Stations-Stammdaten': 'Matični podaci stanice',
  'Status: Entwurf - bitte unten Bewertung + Unterschrift abgeben.': 'Status: nacrt - molim dolje unesi ocjenu + potpis.',
  'Steckanschluss (Außenkonus)': 'Utični priključak (vanjski konus)',
  'Strasse': 'Ulica',
  'Stufe {nr}': 'Stupanj {nr}',
  'Stufenwerte unten eintragen, dann rechnet die App selbst': 'Upiši vrijednosti stupnjeva dolje, aplikacija će sama izračunati',
  'T - Trafoabgang': 'T - transformatorsko polje',
  'TT.MM.JJJJ': 'DD.MM.GGGG',
  'TT.MM.JJJJ, MM.JJJJ oder JJJJ': 'DD.MM.GGGG, MM.GGGG ili GGGG',
  'Telefon': 'Telefon',
  'Thermometer': 'Termometar',
  'Tippe auf ein Bild, um es aus- oder abzuwählen.': 'Dodirni sliku da je odabereš ili poništiš odabir.',
  'Titel': 'Naslov',
  'Trafo': 'Transformator',
  'Trafo OS-seitig gesteckt (Außenkonus): geerdet wird im Trafofeld der Schaltanlage.': 'Transformator utaknut na VN strani (vanjski konus): uzemljuje se u transformatorskom polju rasklopnog postrojenja.',
  'Trafo anlegen': 'Dodaj transformator',
  'Trafo berührungssicher – Balken evtl. nicht nötig; VNB-/UV-Vorgaben beachten.': 'Transformator zaštićen od dodira – prečka možda nije potrebna; poštuj propise ODS-a (VNB) / osiguravatelja (UV).',
  'Trafo mit offenen Anschlüssen: Er muss OS- und US-seitig direkt am Trafo geerdet werden.': 'Transformator s otvorenim priključcima: mora se uzemljiti na VN i NN strani izravno na transformatoru.',
  'Trafo nachtragen': 'Naknadno dodaj transformator',
  'Trafo nicht mehr gefunden (eventuell gelöscht).': 'Transformator više nije pronađen (možda obrisan).',
  'Trafo steht IN der Wanne (verdrängt Volumen)': 'Transformator stoji U kadi (istiskuje volumen)',
  'Trafo {nr}': 'Transformator {nr}',
  'Trafo-Art': 'Vrsta transformatora',
  'Trafo-Art oben auswaehlen, um zu entscheiden ob Oelgewicht-Feld noetig ist.': 'Odaberi vrstu transformatora gore kako bi se odlučilo je li potrebno polje mase ulja.',
  'Trafo-Art oben wählen, dann passt die Liste': 'Odaberi vrstu transformatora gore, tada popis odgovara',
  'Trafo-Stammdaten: {name}': 'Matični podaci transformatora: {name}',
  'Trafo-Ölmenge: {kg} kg ≈ {liter} L': 'Količina ulja transformatora: {kg} kg ≈ {liter} L',
  'Trafo: {name}': 'Transformator: {name}',
  'Trafofeld mit HH-Sicherungen: Sicherungen und Reserve (je Bemessungsstrom) gehören in die Station.': 'Transformatorsko polje s VN osiguračima (HH): osigurači i rezerva (po nazivnoj struji) moraju biti u stanici.',
  'Trotzdem abschließen?': 'Ipak završiti?',
  'Typ': 'Tip',
  'Typ / Modell': 'Tip / model',
  'Typ vom Typenschild': 'Tip s natpisne pločice',
  'Typ „{typ}" ist üblicherweise': 'Tip „{typ}" je obično',
  'UMZ-/Differentialschutz meist nur bei Leistungsschalterfeld – Kurzschlussanzeiger trotzdem prüfen.': 'Nadstrujna (UMZ) / diferencijalna zaštita uglavnom samo kod polja s prekidačem snage – pokazivač kratkog spoja ipak provjeri.',
  'US abgedeckt: Erdung an der nächsten NS-Schaltstelle – dort prüfen.': 'NN strana pokrivena: uzemljenje na najbližem NN rasklopnom mjestu – provjeri tamo.',
  'US abgedeckt: Festpunkte ggf. unter der Abdeckung oder an der NSHV – bitte prüfen.': 'NN strana pokrivena: kuglaste točke možda ispod pokrova ili na glavnom NN razvodu (NSHV) – molim provjeri.',
  'US-Anschluss': 'NN priključak',
  'US-Spannung [kV]': 'NN napon [kV]',
  'Umrechnung: 1 Liter Trafoöl ≈ 1 kg × 1,141': 'Preračunavanje: 1 litra transformatorskog ulja ≈ 1 kg × 1,141',
  'Unbekannt': 'Nepoznato',
  'Unbekannter Fehler': 'Nepoznata greška',
  'Unter 1 kV ist Niederspannung. Gehört der Wert hierher?': 'Ispod 1 kV je niski napon. Pripada li vrijednost ovdje?',
  'Unter 50 kVA ist für eine Trafostation ungewöhnlich. Kilowatt statt kVA eingetragen?': 'Ispod 50 kVA je neuobičajeno za trafostanicu. Upisani kilovati umjesto kVA?',
  'Unterschrift': 'Potpis',
  'Unterschrift Monteur': 'Potpis montera',
  'Upload fehlgeschlagen': 'Učitavanje nije uspjelo',
  'VOM MONTEUR ABGESCHLOSSEN': 'MONTER ZAVRŠIO',
  'Verwaltung': 'Administracija',
  'Vollschutz': 'Potpuna zaštita',
  'Vollständiges Protokoll': 'Potpuni zapisnik',
  'Vom Büro freigeben': 'Odobri (ured)',
  'Vom Monteur abgeschlossen am {datum} - wartet auf Büro-Freigabe': 'Monter završio dana {datum} - čeka odobrenje ureda',
  'Von der Datenbank abgelehnt: {fehler}': 'Baza podataka odbila: {fehler}',
  'Voraussichtlich nötig: am Messfeld bzw. an offenen Trafo-Anschlüssen prüfen, ob eigene Prüfbuchsen vorhanden sind.': 'Vjerojatno potrebno: na mjernom polju odnosno otvorenim priključcima transformatora provjeri postoje li vlastite ispitne utičnice.',
  'Vorhanden': 'Prisutno',
  'Vorschlag aus den festgestellten Mängeln': 'Prijedlog na temelju utvrđenih nedostataka',
  'Vorschlag übernehmen': 'Preuzmi prijedlog',
  'Vorschlag – bitte vor Ort selbst prüfen': 'Prijedlog – molim provjeri sam na licu mjesta',
  'Wanne {wanne} L  <  Trafooel {oel} L. Fehlende Auffangkapazität: {fehlt} L (-{prozent} %). Mängelmeldung erforderlich.': 'Kada {wanne} L  <  ulje transformatora {oel} L. Nedostaje kapacitet: {fehlt} L (-{prozent} %). Potrebna prijava nedostatka.',
  'Wanne {wanne} L  >=  Trafooel {oel} L. Sicherheitsreserve: {reserve} L (+{prozent} %).': 'Kada {wanne} L  >=  ulje transformatora {oel} L. Sigurnosna rezerva: {reserve} L (+{prozent} %).',
  'Wannenmasse (L, B, H) und Trafo-Oelmenge (oben am Trafo unter "Gesamt-Oelgewicht kg") eintragen.': 'Upiši mjere kade (D, Š, V) i količinu ulja transformatora (gore kod transformatora pod "Ukupna masa ulja kg").',
  'Wartet auf deine Freigabe': 'Čeka tvoje odobrenje',
  'Wartung abschließen (Monteur)': 'Završi održavanje (monter)',
  'Wartung durchgeführt von': 'Održavanje proveo',
  'Wartung erfolgreich abgeschlossen. Das Büro kann jetzt prüfen und freigeben.': 'Održavanje uspješno završeno. Ured sada može provjeriti i odobriti.',
  'Wartung jetzt abschliessen? Du kannst danach selbst nichts mehr aendern - nur das Buero.': 'Završiti održavanje sada? Nakon toga sam više ništa ne možeš mijenjati - samo ured.',
  'Wartung starten': 'Pokreni održavanje',
  'Wartungen werden geladen …': 'Učitavaju se održavanja …',
  'Wartungsbericht': 'Izvješće o održavanju',
  'Wartungsprotokoll': 'Zapisnik o održavanju',
  'Wartungsprotokoll als geprüft und freigegeben markieren?': 'Označiti zapisnik o održavanju kao provjeren i odobren?',
  'Warum nicht in Ordnung? (Mehrfachauswahl):': 'Zašto neispravno? (višestruki odabir):',
  'Was prüfen? Worauf achten?': 'Što provjeriti? Na što paziti?',
  'Weiter': 'Dalje',
  'Weiter zum Abschluss': 'Dalje na završetak',
  'Welche Schutzfunktionen sind vorhanden?': 'Koje zaštitne funkcije postoje?',
  'Wirklich löschen?': 'Stvarno obrisati?',
  'Worauf achten:': 'Na što paziti:',
  'Worum geht es:': 'O čemu se radi:',
  'ZIP-Erstellung fehlgeschlagen': 'Izrada ZIP-a nije uspjela',
  'Zum Schalten nicht nötig (Schalthebel) – als Rettungsstange nach Gefährdungsbeurteilung prüfen.': 'Za sklapanje nije potrebna (sklopna ručica) – kao motku za spašavanje provjeri prema procjeni rizika (GBU).',
  'Zur Mängelbeseitigung besteht dringender Handlungsbedarf!': 'Za otklanjanje nedostataka potrebno je hitno djelovati!',
  'Zurück': 'Natrag',
  'Zurück zur Startseite': 'Natrag na početnu stranicu',
  'Zusaetzliche Anmerkungen zur Schutzfunktion': 'Dodatne napomene o zaštitnoj funkciji',
  'Zusatzangaben': 'Dodatni podaci',
  'alle Prüfpunkte': 'sve točke provjere',
  'ein Grund oben, eine Bemerkung oder ein Foto. Eines davon genügt — sonst kann das Büro den Mangel später nicht einordnen.': 'razlog gore, napomena ili fotografija. Dovoljno je jedno od toga — inače ured kasnije ne može razvrstati nedostatak.',
  'entfernen': 'ukloni',
  'für den Kunden': 'za kupca',
  'geplant': 'planirano',
  'in Arbeit': 'u tijeku',
  'ja': 'da',
  'ja, Lebenszyklus erreicht': 'da, životni vijek dosegnut',
  'kein Netz – auf dem Gerät gespeichert': 'nema mreže – spremljeno na uređaju',
  'leeren': 'isprazni',
  'lädt hoch …': 'učitava …',
  'lädt hoch...': 'učitava...',
  'löschen': 'obriši',
  'mit Berührungsschutzhauben': 's kapama za zaštitu od dodira',
  'n. benötigt': 'nije potrebno',
  'n.i.O., wenn:': 'neispravno, ako:',
  'nein': 'ne',
  'nicht bekannt': 'nije poznato',
  'passt nicht zur Trafo-Art': 'ne odgovara vrsti transformatora',
  'speichern': 'spremi',
  'speichert …': 'sprema …',
  'speichert...': 'sprema...',
  'unbekannter Fehler': 'nepoznata greška',
  'wartet auf Netz': 'čeka mrežu',
  'wird angelegt …': 'kreira se …',
  'wird gesendet …': 'šalje se …',
  'x Entfernen': 'x Ukloni',
  'z. B. 0,4': 'npr. 0,4',
  'z. B. 20': 'npr. 20',
  'z. B. 630': 'npr. 630',
  'z. B. 8DJH': 'npr. 8DJH',
  'z. B. Dyn5': 'npr. Dyn5',
  'z. B. J01': 'npr. J01',
  'z. B. Ringkabel Nord': 'npr. prstenasti kabel Sjever',
  'z. B. SGB': 'npr. SGB',
  'z. B. Siemens': 'npr. Siemens',
  'z.B. 3': 'npr. 3',
  'z.B. HSE, Trafo, Mast …': 'npr. HSE, transformator, stup …',
  'z.B. Material, Zustand, Beschichtung': 'npr. materijal, stanje, premaz',
  'z.B. besondere Hinweise, Empfehlungen, Termine': 'npr. posebne napomene, preporuke, termini',
  'zurücksetzen': 'poništi',
  '{fertig} / {gesamt} Prüfpunkte': '{fertig} / {gesamt} točaka provjere',
  '{fertig} / {gesamt} ausgefüllt': '{fertig} / {gesamt} ispunjeno',
  '{imPdf} von {n} Foto wird mitgedruckt.': '{imPdf} od {n} fotografije ispisuje se.',
  '{imPdf} von {n} Fotos werden mitgedruckt.': '{imPdf} od {n} fotografija ispisuje se.',
  '{j}-jährig': '{j}-godišnje',
  '{n} Antwort ist noch nicht übertragen (kein Netz).': '{n} odgovor još nije prenesen (nema mreže).',
  '{n} Antworten sind noch nicht übertragen (kein Netz).': '{n} odgovora još nije preneseno (nema mreže).',
  '{n} Eingabe(n) hat die Datenbank abgelehnt': 'Baza podataka odbila je {n} unos(a)',
  '{n} Eingabe(n) sind auf dem Gerät gespeichert, die Übertragung läuft noch.': '{n} unos(a) spremljeno na uređaju, prijenos je još u tijeku.',
  '{n} Eingaben warten auf Netz.': '{n} unosa čeka mrežu.',
  '{n} Trafos': '{n} transformatora',
  '{tag}, {zeit} Uhr': '{tag}, {zeit} h',
  '{was} hat nicht geklappt: {fehler}. Bitte prüfen, ob die Verbindung steht, und noch einmal versuchen.': '{was} nije uspjelo: {fehler}. Molim provjeri postoji li veza i pokušaj ponovno.',
  '· Aktuell {n} Mangel/Mängel über Grenzwert.': '· Trenutno {n} nedostatak/nedostataka iznad granične vrijednosti.',
  'Öl mit Ausdehner': 'Ulje s konzervatorom',
  'Öl mit Ausdehner: Buchholzschutz und Thermometer prüfen.': 'Ulje s konzervatorom: provjeri Buchholzov relej i termometar.',
  'Ölauffangwanne unter diesem Trafo vorhanden': 'Uljna kada ispod ovog transformatora postoji',
  'Ölprobe entnommen': 'Uzet uzorak ulja',
  'Über 100 Ω ist für eine Erdung sehr hoch. Messgerät oder Komma prüfen.': 'Iznad 100 Ω je vrlo visoko za uzemljenje. Provjeri mjerni uređaj ili zarez.',
  'Über 100 Ω — Komma prüfen?': 'Iznad 100 Ω — provjeriti zarez?',
  'Über 4000 kVA ist selten. Bitte kurz prüfen.': 'Iznad 4000 kVA je rijetko. Molim kratko provjeri.',
  'Über 60 kV - ist der Wert in Volt statt Kilovolt eingetragen?': 'Iznad 60 kV - je li vrijednost upisana u voltima umjesto kilovoltima?',
  'Übergabestation mit MS-Messung: Doppelschließung mit dem VNB abstimmen.': 'Predajna stanica sa SN mjerenjem: dvostruko zaključavanje uskladi s ODS-om (VNB).',
  '„OL“ zeigt das Messgerät, wenn der Wert über dem Messbereich liegt – dann besteht keine leitende Verbindung.': '„OL“ prikazuje mjerni uređaj kad je vrijednost izvan mjernog opsega – tada nema vodljivog spoja.',
  '„{option}" übernehmen': 'Preuzmi „{option}"',
  '↓ Nächster offener Punkt': '↓ Sljedeća otvorena točka',
  '✓ Alles gespeichert ({uhr} Uhr)': '✓ Sve spremljeno ({uhr} h)',
  // Nachtrag 15.09.2026
  'Wartung planen': 'Planiraj održavanje',
  '+ Wartung planen': '+ Planiraj održavanje',
  // Nachtrag v57
  'Gerätespeicher voll! {n} Eingabe(n) sind nur vorläufig gemerkt. App nicht schließen, bis wieder Netz da ist und alles übertragen wurde.':
    'Memorija uređaja je puna! {n} unos(a) je samo privremeno zapamćeno. Ne zatvaraj aplikaciju dok se ne vrati mreža i sve se ne prenese.',
  'Gerätespeicher voll – App bitte nicht schließen, bis alles übertragen ist.':
    'Memorija uređaja je puna – molim ne zatvaraj aplikaciju dok se sve ne prenese.',
  'Stammdaten der Station konnten nicht geladen werden (kein Netz?). Die Prüfpunkte unten lassen sich trotzdem ausfüllen.':
    'Osnovni podaci stanice nisu se mogli učitati (nema mreže?). Točke provjere ispod ipak se mogu ispuniti.',
  'Nochmal laden': 'Učitaj ponovno',
  // Nachtrag v60 (offene Punkte, letzte Wartung, Fotos ohne Netz, Vorab-Laden)
  'Offene Punkte ({n})': 'Otvorene točke ({n})',
  '{n} offene Prüfpunkte': '{n} otvorenih točaka provjere',
  'Alle Prüfpunkte sind beantwortet': 'Sve točke provjere su odgovorene',
  '✓ Nichts mehr offen.': '✓ Ništa više nije otvoreno.',
  'Letzte Wartung': 'Zadnje održavanje',
  'zuletzt': 'zadnje',
  'Wartungen werden für unterwegs gespeichert …': 'Održavanja se spremaju za teren …',
  '📥 {n} Wartung(en) auch ohne Netz verfügbar': '📥 {n} održavanja dostupno i bez mreže',
  'Foto konnte nicht gespeichert werden': 'Fotografija se nije mogla spremiti',
  'Dieses Foto wurde vom Server abgelehnt:': 'Poslužitelj je odbio ovu fotografiju:',
  'OK = noch einmal senden, Abbrechen = weitere Auswahl': 'OK = pošalji ponovno, Odustani = daljnji izbor',
  'Dieses Foto ist noch nicht hochgeladen. Foto löschen?': 'Ova fotografija još nije učitana. Obrisati fotografiju?',
  'Vom Server abgelehnt': 'Poslužitelj je odbio',
  'Wartet auf Netz': 'Čeka na mrežu',
  'Foto abgelehnt – antippen': 'Fotografija odbijena – dodirni',
  '{n} Foto(s) warten auf Netz.': '{n} fotografija čeka na mrežu.',
  'Alle Eingaben gespeichert. {n} Foto(s) warten noch auf Netz und gehen automatisch raus.':
    'Svi unosi spremljeni. {n} fotografija još čeka na mrežu i poslat će se automatski.',
  '{n} Foto(s) sind noch nicht hochgeladen (kein Netz). Sie gehen automatisch raus, fehlen aber in einem PDF, das vorher erstellt wird.':
    '{n} fotografija još nije učitano (nema mreže). Poslat će se automatski, ali neće biti u PDF-u koji se izradi prije toga.',
  'Trotzdem weiter?': 'Ipak nastaviti?',
  'Fällige Wartungen': 'Dospjela održavanja',
  'gespeichert': 'spremljeno',
  'Mangel angelegt': 'Nedostatak evidentiran',
  'freigegeben': 'odobreno',
  'wartet auf Büro': 'čeka ured',
  'abgeschlossen': 'završeno',
  'Entfernen': 'Ukloni',
  'Morgen': 'Sutra',
  'Sonntag': 'Nedjelja',
  'Montag': 'Ponedjeljak',
  'Dienstag': 'Utorak',
  'Mittwoch': 'Srijeda',
  'Donnerstag': 'Četvrtak',
  'Freitag': 'Petak',
  'Samstag': 'Subota',
  'ohne Termin': 'bez termina',
  '1 Trafo': '1 transformator',
  'Kompaktstation': 'Kompaktna stanica',
  'begehbar': 'prohodna',
  'im Gebäude': 'u zgradi',
  'MS-Anlage Luft': 'SN postrojenje zrak',
  'MS-Anlage Luft (offen)': 'SN postrojenje zrak (otvoreno)',
  'MS-Anlage SF6': 'SN postrojenje SF6',
  'MS-Anlage Clean Air': 'SN postrojenje Clean Air',
  'Ölprobe normal': 'Uzorak ulja normalan',
  'Ölprobe mit PCB': 'Uzorak ulja s PCB-om',
  'EVU kommt dazu': 'Distributer (EVU) dolazi',
  'UMZ-Schutzprüfung': 'Ispitivanje UMZ zaštite',
  'Sicherheitszubehör ist mangelhaft oder fehlt': 'Sigurnosni pribor je neispravan ili nedostaje',
  'Erdungsanlage ist mangelhaft': 'Uzemljenje je neispravno',
  'Anlage hat das Ende ihres Lebenszyklus erreicht': 'Postrojenje je dosegnulo kraj životnog vijeka',
  'Türen, Schlösser oder Notentriegelung mangelhaft': 'Vrata, brave ili nužno otključavanje neispravni',
  'Wasser oder Feuchtigkeit in der Station': 'Voda ili vlaga u stanici',
  'Schäden am Stationsgebäude': 'Oštećenja na zgradi stanice',
  // v83 (18.09.2026)
  "Fertigstation mit Anstrich: kein Abmessen nötig – das Auffangvolumen gilt als in Ordnung.": "Gotova stanica s premazom: mjerenje nije potrebno – zapremina se smatra ispravnom.",
  "Erst unten bei 05.1.1 die Ausführung wählen – bei einer Wanne erscheinen hier die Maße zum Abmessen.": "Prvo dolje kod 05.1.1 odabrati izvedbu – kod kade se ovdje pojavljuju dimenzije za mjerenje.",
  "Bauform (sonstiges)": "Izvedba (ostalo)",
  "Bauform eintragen": "Upiši izvedbu",
  "Höhe H [m]": "Visina H [m]",
  "US mit Hauben und Erdungsbolzen: Erdung am Trafo über die Erdungsbolzen – passende Erdungsgarnitur prüfen.": "NN strana s kapama i vijcima za uzemljenje: uzemljenje na transformatoru preko vijaka – provjeri odgovarajući pribor.",
  "Porzellan-Kerzen mit Flachanschluss, mit Erdungsbolzen": "Porculanski provodnici s plosnatim priključkom, s vijcima za uzemljenje",
  "Porzellan-Kerzen mit Flachanschluss, ohne Erdungsbolzen": "Porculanski provodnici s plosnatim priključkom, bez vijaka za uzemljenje",
  "Porzellan-Kerzen mit Anschlussfahne, mit Erdungsbolzen": "Porculanski provodnici s priključnom zastavicom, s vijcima za uzemljenje",
  "Porzellan-Kerzen mit Anschlussfahne, ohne Erdungsbolzen": "Porculanski provodnici s priključnom zastavicom, bez vijaka za uzemljenje",
  "Klemmen ohne Haube, mit Erdungsbolzen": "Stezaljke bez kapa, s vijcima za uzemljenje",
  "Klemmen ohne Haube, ohne Erdungsbolzen": "Stezaljke bez kapa, bez vijaka za uzemljenje",
  "Klemmen mit Hauben, mit Erdungsbolzen": "Stezaljke s kapama, s vijcima za uzemljenje",
  "Klemmen mit Hauben, ohne Erdungsbolzen": "Stezaljke s kapama, bez vijaka za uzemljenje",
  'Lüftung verstopft, blockiert oder beschädigt': 'Ventilacija začepljena, blokirana ili oštećena',
  'Stocher-/Eindringschutz fehlt oder ist beschädigt': 'Zaštita od prodora nedostaje ili je oštećena',
  'Fenster oder Glasbausteine in der Station': 'Prozori ili staklene opeke u stanici',
  'Thermografie zeigt Auffälligkeiten': 'Termografija pokazuje nepravilnosti',
  'Diese Wartung ist abgeschlossen. Änderungen sind nur noch durch das Büro möglich.': 'Ovo održavanje je završeno. Promjene su moguće još samo preko ureda.',
  'Abgeschlossene Wartung – Änderungen des Büros werden sofort übernommen. Ein bereits verschicktes PDF danach neu erstellen.': 'Završeno održavanje – promjene ureda preuzimaju se odmah. Već poslani PDF zatim ponovno izraditi.',
  'Der Abschluss wurde NICHT gespeichert.': 'Završetak NIJE spremljen.',
  'Unterschrift und Bewertung sind auf dem Gerät aufbewahrt – bitte das Büro informieren.': 'Potpis i ocjena sačuvani su na uređaju – molim obavijesti ured.',
  'Ältestes MS-Feld von {jahr} ist {alter} Jahre alt (ab {grenze} Jahren erreicht).': 'Najstarije SN polje iz {jahr} staro je {alter} godina (dosegnuto od {grenze} godina).',
  'Ältestes MS-Feld von {jahr} ist {alter} Jahre alt (unter {grenze} Jahren).': 'Najstarije SN polje iz {jahr} staro je {alter} godina (manje od {grenze} godina).',
  'SF6/Clean Air mit offenen Trafo-Anschlüssen: Spannungsfreiheit an den Anschlüssen mit dem MS-Spannungsprüfer feststellen.': 'SF6/Clean Air s otvorenim priključcima transformatora: beznaponsko stanje na priključcima utvrditi SN ispitivačem napona.',
  'Voraussichtlich nötig: am Messfeld prüfen, ob eigene Prüfbuchsen vorhanden sind.': 'Vjerojatno potrebno: na mjernom polju provjeri postoje li vlastite ispitne utičnice.',
  'SF6/Clean Air: geschaltet wird mit dem Schalthebel – eine Schaltstange ist nicht erforderlich.': 'SF6/Clean Air: sklapa se sklopnom polugom – sklopna motka nije potrebna.',
  '{n} Foto(s) wurden vom Server abgelehnt und gehen NICHT von allein raus.': 'Poslužitelj je odbio {n} fotografija i one se NEĆE same poslati.',
  'Ob noch Fotos auf dem Gerät warten, ließ sich gerade nicht prüfen.': 'Trenutno nije moguće provjeriti čekaju li još fotografije na uređaju.',
  'Alle Eingaben gespeichert. {n} Foto(s) wurden vom Server abgelehnt – beim Foto antippen.': 'Svi unosi spremljeni. Poslužitelj je odbio {n} fotografija – dodirni fotografiju.',
  '{n} Foto(s) abgelehnt – beim Foto antippen.': '{n} fotografija odbijeno – dodirni fotografiju.',
  'Weder Blechwanne noch Beschichtung.': 'Nema ni limene kade ni premaza.',
  'Dann ist keine Ölauffangwanne vorhanden – bitte 05.1 auf „nein" setzen (Mangel).': 'Tada nema uljne kade – molim 05.1 postaviti na „ne" (nedostatak).',
  // 18.09.2026: Trafo-Anschluesse, NS-Kabel, Erder-Grenzwert
  "Bei > {grenze} Ω oder „OL“ wird automatisch ein Mangel angelegt.": "Kod > {grenze} Ω ili „OL“ automatski se stvara nedostatak.",
  "Grenzwert dieser Station: {grenze} Ω": "Granična vrijednost ove stanice: {grenze} Ω",
  "Bitte einen Wert zwischen 0,01 und 100 Ω eintragen.": "Molim upiši vrijednost između 0,01 i 100 Ω.",
  "Früher waren mehrere Bauformen gespeichert: {liste}. Beim Auswählen bleibt nur eine.": "Ranije je bilo spremljeno više izvedbi: {liste}. Odabirom ostaje samo jedna.",
  "Grenzwert Erdungswiderstand": "Granična vrijednost otpora uzemljenja",
  "abweichend vom Standard 2 Ω": "odstupa od standardnih 2 Ω",
  "Standard 2 Ω – nur ändern, wenn der Netzbetreiber etwas anderes fordert (z. B. Hamburg 1 Ω)": "Standardno 2 Ω – mijenjaj samo ako operator mreže traži drugo (npr. Hamburg 1 Ω)",
  "Erst die Bauform wählen, dann passt die Liste": "Prvo odaberi izvedbu, onda popis odgovara",
  "Kabeltyp (sonstiges)": "Tip kabela (ostalo)",
  "Kabeltyp eintragen": "Upiši tip kabela",
  "bitte genauer wählen": "molim odaberi točnije",
  "Meist 3 oder 5 – erzeugt die Felder für die Stufenspannungen": "Najčešće 3 ili 5 – stvara polja za napone stupnjeva",
  "Wird berechnet, sobald alle Stufen oben eingetragen sind": "Izračunava se čim su svi stupnjevi gore upisani",
  "Erst die Anzahl der Schaltstufen eintragen, dann rechnet die App selbst": "Prvo upiši broj stupnjeva, onda aplikacija sama računa",
  "Gießharztrafo: Als Schutz gibt es nur den Kaltleiter.": "Transformator s lijevanom smolom: kao zaštita postoji samo PTC termistor.",
  "Porzellan-Kerzen mit Flachanschluss": "Porculanski provodnici s plosnatim priključkom",
  "Porzellan-Kerzen mit Anschlussfahne": "Porculanski provodnici s priključnom zastavicom",
  "Klemmen ohne Haube": "Stezaljke bez kapa",
  "Klemmen mit Hauben, mit Erdungskugelpunkten": "Stezaljke s kapama, s kuglastim točkama za uzemljenje",
  "Klemmen mit Hauben, ohne Erdungskugelpunkte": "Stezaljke s kapama, bez kuglastih točaka za uzemljenje",
  "Anschlussfahne": "Priključna zastavica",
  "sonstiges": "ostalo",
  "US mit Hauben und Erdungskugelpunkten: Erdung am Trafo über die Kugelpunkte – passende Erdungsgarnitur prüfen.": "NN strana s kapama i kuglastim točkama: uzemljenje na transformatoru preko kuglastih točaka – provjeri odgovarajući pribor za uzemljenje.",
  // v84 (18.09.2026)
  "MS-Räume": "SN prostorije",
  "NS-Räume": "NN prostorije",
  "MS/NS-Räume kombiniert": "Kombinirane SN/NN prostorije",
  "Trafokammern": "Trafo komore",
  "Isoliermatten laut Räumen der Station: {n} Stück (je MS-, NS- und kombiniertem Raum eine).": "Izolacijski tepisi prema prostorijama stanice: {n} kom. (po jedan za svaku SN, NN i kombiniranu prostoriju).",
  // v85
  "Warn- und Hinweisschilder soll: {n} Stück": "Pločice upozorenja potrebno: {n} kom.",
  "{r} Raum/Räume × 4": "{r} prostorija × 4",
  "{n} × Vorsicht Rückspannung": "{n} × Oprez povratni napon",
  "{n} MS-Felder × 2 (nicht schalten / geerdet und kurzgeschlossen)": "{n} SN polja × 2 (ne uključivati / uzemljeno i kratko spojeno)",
  "Feuerlöscher: letzte Prüfung vor {m} Monaten – Prüfung überfällig (alle 2 Jahre).": "Aparat za gašenje: zadnje ispitivanje prije {m} mjeseci – ispitivanje zakašnjelo (svake 2 godine).",
  "Feuerlöscher: nächste Prüfung fällig {datum}.": "Aparat za gašenje: sljedeće ispitivanje {datum}.",
  // v85 E+K
  "Erdungsschalter in den Feldern vorhanden": "Zemljospojnik u poljima postoji",
  "Erdungs- und Kurzschließvorrichtungen soll: {n} Stück (Halterungen ebenso)": "Pribor za uzemljenje i kratko spajanje potrebno: {n} kom. (nosači isto)",
  "Messfelder {n}": "Mjerna polja {n}",
  "Trafos {n}": "Transformatori {n}",
  "Abgänge ohne Erdungsschalter {n}": "Odvodi bez zemljospojnika {n}",
  "Luftanlage: bitte bei der MS-Anlage angeben, ob Erdungsschalter vorhanden sind.": "Zračno postrojenje: molim kod SN postrojenja navesti postoje li zemljospojnici.",
  // v86 UMZ-/Schutzgeraet
  "UMZ- / Schutzgerät": "UMZ / zaštitni uređaj",
  "z. B. Woodward, Siemens, ABB": "npr. Woodward, Siemens, ABB",
  "z. B. WIC1, 7SJ, REJ": "npr. WIC1, 7SJ, REJ",
  "Wandlerübersetzung": "Prijenosni omjer transformatora",
  "z. B. 100/1 A": "npr. 100/1 A",
  "Einstellwerte": "Podešene vrijednosti",
  "Prüfprotokoll: erst die Station speichern, dann hochladen.": "Ispitni zapisnik: najprije spremiti stanicu, zatim učitati.",
  "Hochladen fehlgeschlagen: {fehler}": "Učitavanje nije uspjelo: {fehler}",
  "Öffnen fehlgeschlagen: {fehler}": "Otvaranje nije uspjelo: {fehler}",
  "Prüfprotokoll „{name}“ wirklich löschen?": "Stvarno obrisati ispitni zapisnik „{name}“?",
  "Löschen fehlgeschlagen: {fehler}": "Brisanje nije uspjelo: {fehler}",
  "Schutzprüfprotokolle": "Zapisnici ispitivanja zaštite",
  "Noch kein Prüfprotokoll hinterlegt.": "Još nema ispitnog zapisnika.",
  "Datei öffnen": "Otvori datoteku",
  "Prüfdatum": "Datum ispitivanja",
  "wird hochgeladen …": "učitava se …",
  "+ Prüfprotokoll hochladen (PDF/Foto)": "+ Učitaj ispitni zapisnik (PDF/fotografija)",
  // v87 Abschluss-Kopf
  "Diese Angaben stehen oben im Protokoll für den Kunden.": "Ovi podaci stoje na vrhu zapisnika za kupca.",
  "Grund, warum keine Ölprobe möglich war": "Razlog zašto uzorak ulja nije bio moguć",
  "z. B. kein Probenahmeventil, Hermetik-Trafo": "npr. nema ventila za uzorkovanje, hermetički transformator",
  "Benötigte Leistung [kVA]": "Potrebna snaga [kVA]",
  "nicht möglich": "nije moguće",
  "Aggregat erforderlich für Wartungsmaschinen": "Potreban agregat za strojeve za održavanje",
  "Aggregat als Notstrom für das Kundennetz": "Agregat kao pričuvno napajanje za mrežu kupca",
  // v87 Sichtpruefungszyklus
  "Sichtprüfungen bis zur nächsten fälligen Wartung:": "Vizualni pregledi do sljedećeg dospjelog održavanja:",
  "einmal": "jednom",
  "zweimal": "dvaput",
  // v92 Pruefung 20.09.2026
  "{n} Eingabe ist noch nicht übertragen (kein Netz).": "{n} unos još nije prenesen (nema mreže).",
  "{n} Eingaben sind noch nicht übertragen (kein Netz).": "{n} unosa još nije preneseno (nema mreže).",
  "! Mangel (über {n} Ω)": "! Nedostatak (iznad {n} Ω)",
  "In den Stammdaten ist keine Ölwanne eingetragen – bitte prüfen: bei einem Öltrafo wäre eine fehlende Wanne ein Mangel.": "U matičnim podacima nije unesena uljna kada – molim provjeriti: kod uljnog transformatora nedostatak kade bio bi nedostatak.",
  "Ausstattung der Station": "Oprema stanice",
  // v94 Typenschild / Schaltplan
  "Typenschild MS-Anlage": "Natpisna pločica SN postrojenja",
  "MS-Übersichtsschaltplan": "Pregledna shema SN postrojenja",
  "Typenschild {name}": "Natpisna pločica {name}",
  "dreimal": "triput",
  "Zur Mängelbeseitigung besteht Handlungsbedarf": "Za otklanjanje nedostataka postoji potreba za djelovanjem",
  // v96 Lieferscheine
  "Lieferschein „{name}“ wirklich löschen?": "Stvarno obrisati otpremnicu „{name}“?",
  "Lieferscheine": "Otpremnice",
  "Ohne Netz – es wird der zuletzt geladene Stand gezeigt.": "Bez mreže – prikazuje se zadnje učitano stanje.",
  "Noch kein Lieferschein hinterlegt.": "Još nema otpremnice.",
  "Lieferschein": "Otpremnica",
  "Vom Server abgelehnt: {fehler}": "Poslužitelj je odbio: {fehler}",
  "Unterschrieben von {name} am {datum}": "Potpisao/la {name} dana {datum}",
  "noch nicht unterschrieben": "još nije potpisano",
  "Ansehen": "Pogledaj",
  "Vom Kunden unterschreiben lassen": "Neka kupac potpiše",
  "Lieferschein hochladen (PDF)": "Učitaj otpremnicu (PDF)",
  "Lieferschein unterschreiben": "Potpisati otpremnicu",
  "Name des Kunden": "Ime kupca",
  "Vor- und Nachname": "Ime i prezime",
  "Unterschrift des Kunden": "Potpis kupca",
  "Unterschrift, Name, Datum und Uhrzeit werden unten auf die letzte Seite des Lieferscheins gesetzt.": "Potpis, ime, datum i vrijeme stavljaju se na dno zadnje stranice otpremnice.",
  "wird gespeichert …": "sprema se …",
  "Unterschrift bestätigen": "Potvrdi potpis",
  // v98 Lieferschein-Anzeige
  "Der Lieferschein lässt sich nicht anzeigen: {fehler}": "Otpremnica se ne može prikazati: {fehler}",
  "lädt …": "učitava se …",
  "Dieser Lieferschein ist noch nicht auf dem Gerät. Bitte einmal mit Netz das Protokoll öffnen.": "Ova otpremnica još nije na uređaju. Molim jednom otvoriti zapisnik s mrežom.",
  "Wo soll unterschrieben werden?": "Gdje treba potpisati?",
  "Lieferschein wird geladen …": "Otpremnica se učitava …",
  "Der grüne Rahmen zeigt die Stelle. Stimmt sie nicht, einfach auf die richtige Linie tippen.": "Zeleni okvir pokazuje mjesto. Ako nije točno, dodirnite ispravnu liniju.",
  "Keine Unterschriftszeile gefunden – bitte auf die Linie tippen, auf der unterschrieben wird.": "Linija za potpis nije pronađena – molim dodirnite liniju na kojoj se potpisuje.",
  "Die Unterschrift kommt auf die gewählte Linie, Name, Datum und Uhrzeit klein darüber.": "Potpis se stavlja na odabranu liniju, ime, datum i vrijeme sitno iznad.",
  "Stelle ändern": "Promijeni mjesto",
  // v99 Rueckfragen
  "Foto vom Server abgelehnt": "Poslužitelj je odbio fotografiju",
  "Noch einmal senden": "Pošalji ponovno",
  "Foto löschen": "Obriši fotografiju",
  "Foto wartet auf Netz": "Fotografija čeka mrežu",
  "Dieses Foto ist noch nicht hochgeladen. Es geht automatisch raus, sobald Netz da ist.": "Ova fotografija još nije učitana. Poslat će se automatski čim bude mreže.",
  "Behalten": "Zadrži",
  "Abbrechen – nichts tun": "Odustani – ništa ne raditi",
  // v100 Kompakte Gruppen, Raeume
  "Räume der Station": "Prostorije stanice",
  "n.i.O.": "neispravno",
  "{n} offen": "{n} otvoreno",
  "i.O.": "ispravno",
  "Bemerkung / Foto": "Napomena / fotografija",
  "Traforäume / Trafokammern": "Trafo prostorije / komore",
  // v100 UMZ-Felder, Typenschilder
  "In Schaltfeld [A]": "In polja [A]",
  "Wandlerleistung [VA]": "Snaga transformatora [VA]",
  "z. B. 5": "npr. 5",
  "Wandlerklasse": "Klasa transformatora",
  "z. B. 5P10": "npr. 5P10",
  "Nennstrom Relais [A]": "Nazivna struja releja [A]",
  "z. B. 1": "npr. 1",
  "Typenschild(-er) MS-Anlage": "Natpisna pločica/-e SN postrojenja",
  "Typenschild(-er) {name}": "Natpisna pločica/-e {name}",
  "Bewertung automatisch: Sicherung ist = Sicherung soll → i.O., sonst n.i.O. Einen Soll-Wert, den die App noch nicht kennt, hier eintragen – er wird für diesen Typ gemerkt.": "Automatska ocjena: osigurač stvarno = osigurač zadano → i.O., inače n.i.O. Zadanu vrijednost koju aplikacija još ne poznaje upišite ovdje – zapamtit će se za ovaj tip.",
  "Bitte Hersteller, Typ und die vorhandene Sicherung eintragen. Die Bewertung kommt automatisch (den Soll-Wert ergänzt bei Bedarf das Büro).": "Upišite proizvođača, tip i postojeći osigurač. Ocjena slijedi automatski (zadanu vrijednost po potrebi dopunjuje ured).",
  "Bewertung durch Büro": "Ocjenu daje ured",
  "Hersteller": "Proizvođač",
  "Sicherung ist [A]": "Osigurač stvarno [A]",
  "Sicherung soll [A] (Herstellerangabe)": "Osigurač zadano [A] (podatak proizvođača)",
  "Bitte zuerst im Trafo-Kapitel die Trafo-Art eintragen – die Wanne wird nur bei Öl-Trafos abgemessen.": "Najprije u poglavlju transformatora upišite vrstu transformatora – kada se mjeri samo kod uljnih transformatora.",
  "Vorschlag antippen und frei ergänzen, z. B. „Unterstation Süd 1“": "Dodirnite prijedlog i slobodno dopunite, npr. „Podstanica Jug 1“",
  "Fotos {name}": "Fotografije {name}",
  "Fotos UMZ-/Schutzgerät {feld}": "Fotografije UMZ / zaštitnog uređaja {feld}",
  "Übergabestation": "Predajna stanica",
  "Unterstation": "Podstanica",
  "sonstige": "ostalo",
  "Schriftgröße": "Veličina slova",
  "Normal": "Normalno",
  "Groß": "Veliko",
  "Sehr groß": "Vrlo veliko",
  "Gilt nur auf diesem Gerät. Die ganze App wird größer – Schrift, Knöpfe und Abstände.": "Vrijedi samo na ovom uređaju. Cijela aplikacija postaje veća – slova, gumbi i razmaci.",
  // v106 (08.10.2026): Wandler / Zähler, NSHV-Verteilungen
  "Zähler ({n})": "Brojila ({n})",
  "Wandler / Zähler": "Mjerni transformatori / brojila",
  "Strom- und Spannungswandler sowie Zähler der Station. Änderungen gehen direkt in die Stammdaten.": "Strujni i naponski mjerni transformatori te brojila stanice. Promjene idu izravno u matične podatke.",
  "kein Netz?": "nema mreže?",
  "Verteilung „{name}“ mit ihren Prüfpunkten entfernen?": "Ukloniti razdjelnik „{name}“ s njegovim točkama provjere?",
  "Konnte nicht entfernt werden.": "Nije moguće ukloniti.",
  "Weitere Verteilung": "Dodatni razdjelnik",
  "Verteilung": "Razdjelnik",
  "ohne Bezeichnung": "bez oznake",
  "Bezeichnung ändern": "Promijeni oznaku",
  "Bezeichnung der Verteilung, z. B. „NSHV“ oder „VT 2 Keller“": "Oznaka razdjelnika, npr. „GNNR“ ili „VT 2 podrum“",
  "Übernehmen": "Preuzmi",
  "Die Verteilung konnte nicht angelegt werden: {fehler}": "Razdjelnik nije moguće dodati: {fehler}",
  "+ weitere Verteilung (z. B. VT 2 Keller)": "+ dodatni razdjelnik (npr. VT 2 podrum)",
  "Bekommt ein eigenes Kapitel mit allen NSHV-Prüfpunkten und bleibt in den Stammdaten der Station – bei der nächsten Wartung ist sie wieder dabei.": "Dobiva vlastito poglavlje sa svim točkama provjere NN razdjelnika i ostaje u matičnim podacima stanice – pri sljedećem održavanju ponovno je uključen.",
  "Bezeichnung, z. B. \"VT 2 Keller\"": "Oznaka, npr. \"VT 2 podrum\"",
  "Verteilung anlegen": "Dodaj razdjelnik",
  "{n} erfasst": "{n} uneseno",
  "Zähler {nr} wirklich entfernen?": "Stvarno ukloniti brojilo {nr}?",
  "Noch kein Zähler erfasst.": "Još nije uneseno brojilo.",
  "Zähler {nr}": "Brojilo {nr}",
  "Zählerbezeichnung (Name)": "Oznaka brojila (naziv)",
  "z. B. Hauptzähler, Allgemeinstrom": "npr. glavno brojilo, opća potrošnja",
  "Zählernummer": "Broj brojila",
  "Wandlerverhältnis": "Prijenosni omjer",
  "+ Zähler": "+ brojilo",
  "nicht im Kundendruck": "ne ispisuje se za kupca",
  "Foto hinzufügen": "Dodaj fotografiju",
  "Weiteres Foto": "Još jedna fotografija",
  "Vollprotokoll": "Cijeli zapisnik",
  "Kundenbericht": "Izvještaj za kupca",
};
